import React, { useEffect, useState } from "react";
import {
  Checkbox,
  Dialog,
  FormControlLabel,
  ThemeProvider,
  Tooltip,
  Typography,
  createTheme,
} from "@mui/material";
import "./modal.css";
import CustomButton from "../../reusableComponents/CustomButton";
import { colorBrandObject } from "../../../constants/brandings";
import { sortArrayValue } from "../utils/utils";

const theme = createTheme({
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "black",
          "&$checked": {
            color: "black",
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: "black",
          "&$checked": {
            color: "black",
          },
        },
      },
    },
  },
});

function ModalWithSearchbar({
  sendDataFromWithSearchbar = () => { },
  onClose = () => { },
  modalLabel,
  modalListLabels,
  multiselector,
  schemaId,
  openModal,
  value,
  displayLogo,
  uniqueType,
  showTitleType,
  showFilterTitle,
  searchbarData,
}) {

  const [modalCheckboxArray, setModalCheckboxArray] = useState([]);
  const [selectedCheckboxArray, setSelectedCheckboxArray] = useState([]);
  const [filterModalLabels, setFilterModalLabels] = useState([]);

  useEffect(() => {
    setSelectedCheckboxArray(searchbarData);
  }, [searchbarData, modalListLabels]);

  const handleCheckboxChanges = (event) => {
    const checkboxId = event.target.id;
    const checkboxValue = event.target.value;
    const isChecked = event.target.checked;
    setSelectedCheckboxArray((prevCheckboxes) => {
      let updatedCheckboxes = [...prevCheckboxes];

      const checkbox = updatedCheckboxes.find(
        (checkbox) => checkbox.id === checkboxId
      );

      if (isChecked) {
        if (checkbox) {
          if (!checkbox?.value?.includes(checkboxValue)) {
            checkbox.value.push(checkboxValue);
          }
        } else {
          updatedCheckboxes.push({ id: checkboxId, value: [checkboxValue] });
        }
      } else {
        if (checkbox) {
          checkbox.value = checkbox.value.filter(
            (value) => value !== checkboxValue
          );
          if (checkbox.value.length === 0) {
            updatedCheckboxes = updatedCheckboxes.filter(
              (checkbox) => checkbox.id !== checkboxId
            );
          }
        }
      }

      return updatedCheckboxes;
    });
  };

  function submitCheckValue() {
    const valueTobeSubmitted = JSON.parse(
      JSON.stringify(selectedCheckboxArray)
    );
    setModalCheckboxArray(valueTobeSubmitted);
    sendDataFromWithSearchbar(valueTobeSubmitted);
    onClose();
  }

  const submitCustomizeButton = () => { };

  const handleCloseModal = () => {
    setSelectedCheckboxArray(JSON.parse(JSON.stringify(modalCheckboxArray)));
    onClose();
  };

  const handleClearAllData = () => {
    const updatedId = selectedCheckboxArray.filter((obj) => obj.id !== schemaId);
    setSelectedCheckboxArray(updatedId);
  };

  const uniqueTypes = new Set();
  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      handleCloseModal();
    }
  };

  useEffect(() => {
    if (modalListLabels?.length) {
      let filteredModalList = []
      if (modalListLabels[0]?.value) {
        filteredModalList = sortArrayValue(
          modalListLabels,
          'value'
        );
      } else {
        filteredModalList = sortArrayValue(
          modalListLabels,
          showTitleType ? "typeTitle" : "title"
        );
      }
      setFilterModalLabels(filteredModalList);
    }
  }, [modalListLabels]);

  const getTooltipTitle = (item, showFilterTitle, schemaId, showTitleType) => {
    if (showFilterTitle) {
      return item?.title;
    }
    if (schemaId === "metadata.SETTLEMENT_CURRENCY") {
      return item?.value;
    }
    if (item?.label === "Authorisation" || item?.value === "Authorisation") {
      return "Sale";
    }
    if (item?.label || item?.value) {
      return item?.label || item?.value;
    }
    return showTitleType ? item?.typeTitle : item?.title || item?.name;
  };


  return (
    <>
      <Dialog
        className="orderManagementModal"
        open={openModal}
        onKeyDown={handleKeyDown}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "6px",
            padding: "24px 24px 0px 24px",
          }}
        >
          <Typography className="SemiboldTwenty font-black-highest">
            {modalLabel}
          </Typography>
          <img
            src="/assets/ic_twotone-close.svg"
            alt="cross"
            onClick={() => handleCloseModal()}
            style={{ cursor: "pointer" }}
          />
        </div>
        <Typography
          className="labelRegular font-black-high"
          style={{ padding: "0px 24px" }}
        >
          Select your {modalLabel}
        </Typography>
        <div
          style={{
            marginTop: "20px",
            height: "282px",
            overflowY: "scroll",
            padding: "0px 24px",
          }}
        >
          <div
            className="row modalCheckbox"
            style={{
              marginLeft: "4px",
              marginRight: "0px",
            }}
          >
            {multiselector &&
              filterModalLabels?.map((item, idx) => {
                if (uniqueType && uniqueTypes.has(item.type)) {
                  return null;
                }
                const checkboxValue = item?.value || item?.type || item?.code || item?.name; // TODO remove
                const isChecked = selectedCheckboxArray?.some(
                  (checkbox) =>
                    checkbox.id === schemaId &&
                    checkbox?.value?.includes(checkboxValue)
                );
                if (uniqueType) {
                  uniqueTypes.add(item.type);
                }
                return (
                  <div
                    key={idx}
                    className="col-6"
                    style={{ width: "50%", height: "40px" }}
                  >
                    <ThemeProvider theme={theme}>
                      <FormControlLabel
                        control={
                          <>
                            <Checkbox
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  color: colorBrandObject?.secondaryButtonColor,
                                },
                                "&.Mui-checked": {
                                  color: colorBrandObject?.secondaryButtonColor,
                                  "& .MuiSvgIcon-root": {
                                    fill: colorBrandObject?.secondaryButtonColor,
                                  },
                                },
                              }}
                              style={{
                                fontFamily: "Poppins",
                                fontWeight: "500",
                                fontSize: "14px",
                                height: "18px",
                                color: "rgba(36, 183, 170, 1)",
                                marginRight: "8px",
                              }}
                              id={schemaId}
                              checked={isChecked}
                              value={checkboxValue}
                              onChange={handleCheckboxChanges}
                            />
                            {displayLogo && (
                              <img
                                src={item?.logoUrl || item?.pspLogoUrl || item?.additionalData?.pspLogoUrl}
                                style={{
                                  marginRight: "8px",
                                  height: "20px",
                                  width: "20px",
                                }}
                              />
                            )}
                          </>
                        }
                        label={
                          <Tooltip title={getTooltipTitle(item, showFilterTitle, schemaId, showTitleType)}   >
                            <Typography
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "200px", // Adjust width as needed
                                display: "block",
                                cursor: "pointer",
                                fontSize: "14px",
                              }}
                            >
                              {getTooltipTitle(item, showFilterTitle, schemaId, showTitleType)}
                            </Typography>
                          </Tooltip>
                        }
                      />
                    </ThemeProvider>
                  </div>
                );
              })}
          </div>
        </div>
        <div
          style={{
            paddingBottom: "24px",
            paddingTop: "24px",
            display: "flex",
            justifyContent: "end",
            paddingRight: "24px",
            boxShadow: "0px -2px 8px 0px rgba(39, 39, 39, 0.15)",
          }}
        >
          <CustomButton
            variant={"outlined"}
            size={"sm"}
            type={"secondary"}
            text={"Clear All"}
            onClick={handleClearAllData}
          />
          <div style={{ marginLeft: "8px" }}>
            <CustomButton
              variant={"contained"}
              size={"sm"}
              type={"secondary"}
              text={"Apply"}
              onClick={
                value === "customize" ? submitCustomizeButton : submitCheckValue
              }
            />
          </div>
        </div>
      </Dialog>
    </>
  );
}

export default ModalWithSearchbar;

